
const useHost = () => {
    const host = location.host.toLowerCase();
    if (host.includes("scored.co")) return "scored.co";
    if (host.includes("communities.win")) return "communities.win";
    if (host.includes("patriots.win")) return "patriots.win";
    return "";
}

export default useHost;
